// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"86753681","453":"1f960028","923":"6851e50e"}[chunkId] + ".chunk.js";
};